export default __webpack_public_path__ + "static/media/SONICKO.b571768f.png";